import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Divider,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { formatDateFromDB } from '../../../../../utils/FormatDate';
import { useTranslation } from 'react-i18next';

const DetaljiRN = ({ dataPonude, showSuma, handleIsExpanded, naplacujeSe }) => {
  console.log('SUMA', dataPonude);
  const { t, i18n } = useTranslation();
  return (
    <div>
      {dataPonude.zaglavlje &&
        dataPonude.zaglavlje.map((zag, index) => (
          <Accordion
            key={zag.id}
            defaultExpanded={index === 0}
            onChange={(e, expanded) =>
              handleIsExpanded(e, expanded, 'zaglavlje')
            }
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography style={{ fontWeight: 'bold' }}>
                {zag.ceoBrDok} - {zag.status} <br />
                {!showSuma.delovi && (
                  <>
                    {t('totalAmount')}:{' '}
                    {dataPonude.zaglavlje[0]
                      ? dataPonude.zaglavlje[0].ukupno
                      : ''}{' '}
                    €
                  </>
                )}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                <strong>{t('date')}:</strong> {formatDateFromDB(zag.datum)}
              </Typography>
              {/* <Typography>
                <strong>{t('workDescription')}:</strong> {zag.opisRadova}
              </Typography> */}
              <Typography>
                <strong>{t('client')}:</strong> {zag.nazivKupca}
              </Typography>
              <Typography>
                <strong>{t(zag.nazivTipaMasine)}:</strong> {zag.nazivMasine}
              </Typography>
              {/* <span
                style={{
                  fontSize: '20px',
                  fontWeight: 'bold',
                  backgroundColor: '#e7e5e5',
                  float: 'right',
                  paddingLeft: '3px',
                  paddingRight: '3px',
                  marginBottom: '4px',
                }}
              >
                {' '}
                Ukupna cena:{' '}
                {dataPonude.zaglavlje[0]
                  ? dataPonude.zaglavlje[0].ukupno
                  : ''}{' '}
                €
              </span> */}
            </AccordionDetails>
          </Accordion>
        ))}

      {dataPonude.stavkeZaposleni && (
        <Accordion
          onChange={(e, expanded) => handleIsExpanded(e, expanded, 'zaposleni')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography style={{ fontWeight: 'bold' }}>
              {t('employeeCost')}
              <br />
              {!showSuma.zaposleni && (
                <>
                  {t('totalAmount')}:{' '}
                  {dataPonude.stavkeZaposleni[0]
                    ? dataPonude.stavkeZaposleni[0].zaNaplatu
                    : 0}{' '}
                  €
                </>
              )}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {dataPonude.stavkeZaposleni.map((stavka, index) => (
              <Box key={stavka.id} mb={2}>
                <Typography>
                  <strong>{t('employee')}:</strong> {stavka.imeZaposlenog}
                </Typography>
                <Typography>
                  <strong>{t('serviceType')}:</strong> {stavka.nazivUsluge}
                </Typography>
                <Typography>
                  <strong>{t('quantity')}:</strong> {stavka.kolicina}{' '}
                  {stavka.jm}
                </Typography>
                <Typography>
                  <strong>{t('grossEmployeeCost')}:</strong> {stavka.brutoCena}{' '}
                  €
                </Typography>
                {naplacujeSe && (
                  <Typography>
                    <strong>Cena prema klijentu:</strong>{' '}
                    {stavka.cenaPremaKlijentu} €
                  </Typography>
                )}

                <Typography>
                  <strong>{t('date')}:</strong> {formatDateFromDB(stavka.datum)}
                </Typography>
                <Typography>
                  <strong>{t('note')}:</strong> {stavka.napomena}
                </Typography>

                {index < dataPonude.stavkeZaposleni.length - 1 && <Divider />}
              </Box>
            ))}
            <span
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
                backgroundColor: '#e7e5e5',
                float: 'right',
                paddingLeft: '3px',
                paddingRight: '3px',
                marginBottom: '4px',
              }}
            >
              {' '}
              {t('totalAmount')}:{' '}
              {dataPonude.stavkeZaposleni[0]
                ? dataPonude.stavkeZaposleni[0].zaNaplatu
                : ''}{' '}
              €
            </span>
          </AccordionDetails>
        </Accordion>
      )}

      {dataPonude.stavkeTransport && (
        <Accordion
          onChange={(e, expanded) => handleIsExpanded(e, expanded, 'transport')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography style={{ fontWeight: 'bold' }}>
              Trošak putovanja <br />
              {!showSuma.transport && (
                <>
                  {t('totalAmount')}:{' '}
                  {dataPonude.stavkeTransport[0]
                    ? dataPonude.stavkeTransport[0].zaNaplatu
                    : 0}{' '}
                  €
                </>
              )}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {dataPonude.stavkeTransport.map((stavka, index) => (
              <Box key={stavka.id} mb={2}>
                <Typography>
                  <strong>{t('employee')}:</strong> {stavka.imeZaposlenog}
                </Typography>
                <Typography>
                  <strong>{t('serviceType')}:</strong> {stavka.nazivUsluge}
                </Typography>
                <Typography>
                  <strong>{t('quantity')}:</strong> {stavka.kolicina}{' '}
                  {stavka.jm}
                </Typography>
                <Typography>
                  <strong>{t('grossEmployeeCost')}:</strong> {stavka.brutoCena}{' '}
                  €
                </Typography>
                {naplacujeSe && (
                  <Typography>
                    <strong>Cena prema klijentu:</strong>{' '}
                    {stavka.cenaPremaKlijentu} €
                  </Typography>
                )}
                <Typography>
                  <strong>{t('date')}:</strong> {formatDateFromDB(stavka.datum)}
                </Typography>
                <Typography>
                  <strong>{t('note')}:</strong> {stavka.napomena}
                </Typography>
                {index < dataPonude.stavkeTransport.length - 1 && <Divider />}
              </Box>
            ))}
            <span
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
                backgroundColor: '#e7e5e5',
                float: 'right',
                paddingLeft: '3px',
                paddingRight: '3px',
                marginBottom: '4px',
              }}
            >
              {' '}
              {t('totalAmount')}:{' '}
              {dataPonude.stavkeTransport[0]
                ? dataPonude.stavkeTransport[0].zaNaplatu
                : ''}{' '}
              €
            </span>
          </AccordionDetails>
        </Accordion>
      )}

      {dataPonude.stavkeDelovi && (
        <Accordion
          onChange={(e, expanded) => handleIsExpanded(e, expanded, 'delovi')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography style={{ fontWeight: 'bold' }}>
              {t('partsCost')}
              <br />
              {!showSuma.delovi && (
                <>
                  {t('totalAmount')}:{' '}
                  {dataPonude.stavkeDelovi[0]
                    ? dataPonude.stavkeDelovi[0].zaNaplatu
                    : 0}{' '}
                  €
                </>
              )}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {dataPonude.stavkeDelovi.map((stavka, index) => (
              <Box key={stavka.id} mb={2}>
                <Typography>
                  <strong>{t('partName')}:</strong> {stavka.nazivDela}
                </Typography>
                <Typography>
                  <strong>{t('quantity')}:</strong> {stavka.kolicina}{' '}
                  {stavka.jm}
                </Typography>
                <Typography>
                  <strong>{t('grossEmployeeCost')}:</strong> {stavka.brutoCena}{' '}
                  €
                </Typography>
                {naplacujeSe && (
                  <Typography>
                    <strong>Cena prema klijentu:</strong>{' '}
                    {stavka.cenaPremaKlijentu} €
                  </Typography>
                )}
                <Typography>
                  <strong>{t('note')}:</strong> {stavka.napomena}
                </Typography>
                {index < dataPonude.stavkeDelovi.length - 1 && <Divider />}
              </Box>
            ))}
            <span
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
                backgroundColor: '#e7e5e5',
                float: 'right',
                paddingLeft: '3px',
                paddingRight: '3px',
                marginBottom: '4px',
              }}
            >
              {' '}
              {t('totalAmount')}:{' '}
              {dataPonude.stavkeDelovi[0]
                ? dataPonude.stavkeDelovi[0].zaNaplatu
                : ''}{' '}
              €
            </span>
          </AccordionDetails>
        </Accordion>
      )}

      {dataPonude.stavkeTroskovi && (
        <Accordion
          onChange={(e, expanded) => handleIsExpanded(e, expanded, 'troskovi')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography style={{ fontWeight: 'bold' }}>
              {t('additionalCosts')} <br />
              {!showSuma.troskovi && (
                <>
                  {t('totalAmount')}:{' '}
                  {dataPonude.stavkeTroskovi[0]
                    ? dataPonude.stavkeTroskovi[0].zaNaplatu
                    : 0}{' '}
                  €
                </>
              )}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {dataPonude.stavkeTroskovi.map((stavka, index) => (
              <Box key={stavka.id} mb={2}>
                <Typography>
                  <strong>{t('expenseType')}:</strong> {stavka.nazivUsluge}
                </Typography>
                <Typography>
                  <strong>{t('quantity')}:</strong> {stavka.kolicina}{' '}
                  {stavka.jm}
                </Typography>
                <Typography>
                  <strong>{t('grossEmployeeCost')}:</strong> {stavka.brutoCena}{' '}
                  €
                </Typography>
                {naplacujeSe && (
                  <Typography>
                    <strong>Cena prema klijentu:</strong>{' '}
                    {stavka.cenaPremaKlijentu} €
                  </Typography>
                )}
                {/* <Typography>
                  <strong>Usluga:</strong> {stavka.nazivUsluge}
                </Typography> */}
                {index < dataPonude.stavkeTroskovi.length - 1 && <Divider />}
              </Box>
            ))}
            <span
              style={{
                fontSize: '20px',
                fontWeight: 'bold',
                backgroundColor: '#e7e5e5',
                float: 'right',
                paddingLeft: '3px',
                paddingRight: '3px',
                marginBottom: '4px',
              }}
            >
              {' '}
              {t('totalAmount')}:{' '}
              {dataPonude.stavkeTroskovi[0]
                ? dataPonude.stavkeTroskovi[0].zaNaplatu
                : ''}{' '}
              €
            </span>
          </AccordionDetails>
        </Accordion>
      )}
    </div>
  );
};

export default DetaljiRN;
